import React, { useEffect, useState } from "react";
import { TextField, Button, Icon, Typography } from "@mui/material";
import request from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import {
  createSalestargetdetails,
  salesRolesUsers,
  updateSalestargetdetails,
} from "./grphql";
import { useLoading } from "../../context/LodingContext";
import MaterialButton from "../../components/MaterialButton";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import { useSuccess } from "../../context/SucccessContext";
import { useError } from "../../context/ErrorContext";
import { useNavigate } from "react-router-dom";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { fromGlobalId } from "../../lib/decoded/rawPk";
import MaterialTypography from "../../components/MaterialTypography";

const UserTargetTable = ({
  targetValue,
  totalamount,
  yearData,
  updateData,
  id,
}) => {
  const [data, setData] = useState([]);
  const [empetyArray, setEmpetyArray] = useState([]);
  const [editIdx, setEditIdx] = useState(-1);
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus } = useError();
  const [totalTarget, setTotaltarget] = useState(0);
  const [balanceAmount, setBalanceAmount] = useState(0);
  const [disbled, setDisbled] = useState(true);
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const { id: rawPk } = fromGlobalId(currentUser?.id);

  const handleEdit = (index) => {
    setEditIdx(index);
  };

  useEffect(() => {
    if (updateData) {
      setData(updateData);
    }
  }, [updateData]);

 

  useEffect(() => {
    setCirleLoading(true);
    const amount = targetValue / data?.length;
    const setamount = data?.map((v, i) => ({
      ...v,
      targetAmount:amount.toFixed(2)
    }));

    setData(setamount);
    setCirleLoading(false);
  }, [targetValue]);

  useEffect(() => {
    const finalAmount = data?.reduce((acc, cur) => {
      return acc + Number(cur?.targetAmount);
    }, 0);

    const balance = (targetValue - Math.round(finalAmount) );

    setBalanceAmount(balance);
    
    setTotaltarget(Math.round(finalAmount));
  }, [data]);

  useEffect(() => {
    fetchdata();
  }, []);

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      // yearData?.financialyearStartStatus === "success" &&
      // yearData?.financialyearEndStatus === "success" &&
      yearData?.maximumAmountStatus === "success" &&
      yearData?.minimumAmountStatus === "success" &&
      totalTarget == totalamount
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const fetchdata = async () => {
    setCirleLoading(true);
    try {
      const res = await request(BASEURL, salesRolesUsers);

      const set = res?.salesRolesUsers?.map((v, i) => ({
        ...v,
        targetAmount: 0,
      }));
      setData(set);
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };
  const handleSave = () => {
    setEditIdx(-1);
  };

  const handleChange = (e, index, field) => {
    const updatedData = [...data];
    const newUpdateData = [...data];

    updatedData[index][field] = e.target.value;
    const Entervalue = (newUpdateData[index][field] = e.target.value);

    const divedvalue = data?.length - 1;
    const blanceValue = targetValue - Entervalue;

    const dividevalue = blanceValue / divedvalue;

    // updatedData.forEach((v, i) => {
    //   if (i == index) {
    //     v.targetAmount = Entervalue;
    //   } else {
    //     v.targetAmount = dividevalue;
    //   }
    // });

    // const totalamount2 = updatedData?.reduce(
    //   (acc, cur) => acc + Number(cur?.targetAmount),
    //   0
    // );

    setData(updatedData);
  };

  const handleYearlysent = async () => {
    setCirleLoading(true);
    const salesdata = data?.map((v, i) => ({
      user: v?.id,
      targetAmount: v?.targetAmount
    }));

    try {
      
      const res = await request(BASEURL, createSalestargetdetails, {
        input: {
          user: rawPk,
          financialyearStart: yearData?.financialyearStart,
          financialyearEnd: yearData?.financialyearEnd,
          maximumAmount: Math.round(yearData?.maximumAmount),
          minimumAmount: Math.round(yearData?.minimumAmount),
          salesTargetTable: salesdata,
        },
      });
      setSuccessStatus(true);
      setTimeout(() => {
        setSuccessStatus(false);
        navigate("/SalesTarget/");
      }, 2000);
    } catch (err) {
      setErrorStatus(true);
    } finally {
      setCirleLoading(false);
    }
  };

  const handleUpdateYearly = async () => {
    const salesdata = data?.map((v, i) => ({
      id: v?.id,
      targetAmount: v?.targetAmount,
    }));
    setCirleLoading(true);
    try {
      const res = await request(BASEURL, updateSalestargetdetails, {
        input: {
          id: id,
          financialyearStart: yearData?.financialyearStart,
          financialyearEnd: yearData?.financialyearEnd,
          maximumAmount: yearData?.maximumAmount,
          minimumAmount: yearData?.minimumAmount,
          salesTargetTable: salesdata,
        },
      });
      setSuccessStatus(true);
      setTimeout(() => {
        setSuccessStatus(false);
        navigate("/SalesTarget");
      }, 3000);
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };

  return (
    <div className="tabel-target">
      <table>
        <thead>
          <tr>
            <th>S.No.</th>
            <th>Employee Name</th>
            <th>Target Amount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              <td><MaterialTypography
                  component="label"
                  variant="caption"
                  >{index + 1}
              </MaterialTypography></td>
              <td><MaterialTypography
                  component="label"
                  variant="caption"
                  >{row.username || row?.user?.username}</MaterialTypography></td>
              <td
                style={{
                  display: "flex",
                  marginTop: "5px",
                  marginLeft: "5px",
                  marginRight: "5px",
                  marginBottom: "5px",
                  alignItems: "center",
                }}
              >
                <MaterialTypography
                component="label"
                variant="caption"
                >
                    {editIdx === index ? (
                    <TextField
                        type="number"
                        value={row.targetAmount}
                        onChange={(e) => handleChange(e, index, "targetAmount")}
                      />
                    ) : (
                      row.targetAmount || 0
                    )}

                    <CurrencyRupeeIcon sx={{ marginLeft: "10px" }} />
                </MaterialTypography>
              </td>
              <td>
                {editIdx === index ? (
                  <Button onClick={handleSave}>Save</Button>
                ) : (
                  <Button onClick={() => handleEdit(index)}>Edit</Button>
                )}
              </td>
            </tr>
          ))}
          <tr>
              <td
              style={{
                backgroundColor:"#eeeeee",
              }}></td>
              <td>
              <MaterialTypography
              component="label"
              variant="body2">
                      Balance Amount
              </MaterialTypography></td>
              <td
              style={{
                display: "flex",
                marginLeft: "5px",
                marginRight: "5px",
                marginTop: "5px",
                marginBottom: "5px",
                alignItems: "center",
                fontWeight: "600",
                fontSize: "16px",
              }}
            >
              
              { balanceAmount }{" "}
              <CurrencyRupeeIcon sx={{ marginLeft: "10px" }} />
              </td>
              <td
              style={{
                backgroundColor: "#f1f1f1",
              }}></td>
          </tr>
          {/* component="label"
            variant="caption"
            fontWeight="bold" */}
          <tr>
            <td
            style={{
              backgroundColor: "#f1f1f1",
            }}></td>
            <td><MaterialTypography
            component="label"
            variant="body2"
            >Total Amount</MaterialTypography></td>
            <td
              style={{
                display: "flex",
                marginTop: "5px",
                marginBottom: "5px",
                marginLeft: "5px",
                marginRight: "5px",
                alignItems: "center",
                fontWeight: "600",
                fontSize: "16px",
              }}
            >
              {totalamount || "0"}{" "}
              <CurrencyRupeeIcon sx={{ marginLeft: "10px" }} />
            </td>
            <td
            style={{
              backgroundColor: "#eeeeee",
            }}>
              {" "}
              <MaterialButton
                variant="gradient"
                color="dark"
                // disabled={totalTarget == totalamount ? false : true}
                disabled={!checkAllFields()}
                onClick={updateData ? handleUpdateYearly : handleYearlysent}
              >
                {updateData ? "Updated" : "Submit"}   
              </MaterialButton>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default UserTargetTable;
